import { useParams, useSearchParams } from "react-router-dom";
import Header from "../component/menu/Header";
import SideMenu from "../component/menu/SideMenu";
import FormHeaderComponent from "../component/FormHeaderComponent";
import { constants } from "../constant/constants";
import BranchCreateEditComponent from "../component/restaurants/branches/BranchCreateEditComponent";

export default function BranchCreate() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const restaurantName = searchParams.get('restaurantName');
  const {restaurantId} = params;

  console.log('restaurantName', restaurantId);

  return (
    <section>
      <div className="flex flex-col bg-[#e5e7eb]">
        <Header title={""} menu={constants.SUPER_MENU.RESTAURANT} currentMenuKey={'T_51_S_51'}/>
        <div className="flex flex-row bg-prewhite">
          <SideMenu
            title={`McDonalds Food Chain`}
            menu={constants.SUPER_MENU.RESTAURANT}
          />
          <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
            <div className="flex flex-col w-full">
              <FormHeaderComponent
                title={`Branch Create for ${restaurantName}`}
                listRoute={`/restaurants/${restaurantId}/details`}
              />
              <div className="">
                {restaurantName !== "" && (
                  <BranchCreateEditComponent
                    key={'branch-create'}
                    keyProp={'create'}
                    records={{
                      _data: {
                        restaurantName: restaurantName,
                        restaurantId: restaurantId,
                        customersPaymentOptions: ["COUNTER", "ONLINE"],
                        adminsPaymentOptions: ["CASH", "POS", "BKASH", "NAGAD"]
                      },
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
